module.exports = __webpack_public_path__ + "img/image.e596506e.png";